import { useProgress } from "@react-three/drei";
type LoaderProps = {
  styledLoaderPage: JSX.Element;
};

export const withProgress = (Component: any) => (props: any) => {
  // eslint-disable-next-line @typescript-eslint/no-unused-vars
  const { active, progress, errors, item, loaded, total } = useProgress();
  // console.log(
  //   `active ${active} errors ${errors} item ${item} total ${total} loaded ${loaded}`
  // );
  return (
    <Component
      {...props}
      progress={progress}
      active={active}
      loaded={loaded}
      total={total}
    />
  );
};

export function LoaderComponent({ styledLoaderPage }: LoaderProps) {
  // console.log('styledLoaderPage.props', styledLoaderPage.props);
  return (
    <>{styledLoaderPage}</>
    //   <div>
    //     <div>{progress} % loaded</div>
    //     <div>{`active ${active} errors ${errors} item ${item} total ${total}`}</div>
    //   </div>
  );
}
